// extracted by mini-css-extract-plugin
export default {"orderItem":"OrderItem_orderItem__roOQL","imgWrapper":"OrderItem_imgWrapper__BHbaw","itemDescription":"OrderItem_itemDescription__6x3LA","quantity":"OrderItem_quantity__AZbhQ"};